@let chartCurrentOrProposedId = store.chartIdSg();
@let hasSelectedNode =
  !!chartCurrentOrProposedId &&
  !!store.treeEditorFeature.cytoscapeManager.getSelectedNodeId({
    chartId: chartCurrentOrProposedId,
  });

@let chartCurrentId = chartCurrentIdSg();
@let chartProposedId = chartProposedIdSg();
@let isMutating =
  chartCurrentOrProposedId &&
  store.treeEditorFeature.selectors
    .isMutating({
      chartId: chartCurrentOrProposedId,
    })
    .asSignal();

@let widgetRefId = widgetStore.refIdSg();

<div class="atn-summit-org-chart-tools">
  <div class="atn-summit-org-chart-tools__group">
    <!-- Add -->
    @if (chartProposedId) {
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        [loading]="isMutating"
        (click)="
          chartCurrentOrProposedId &&
            !isMutating &&
            store.treeEditorFeature.actions.addNode
              .from('OrgChartTools.AddButton.Clicked')
              .dispatch({ chartId: chartCurrentOrProposedId })
        "
      >
        <i class="atn-icon atn-plus atn-blue"></i>
      </atn-ds-button>
    }

    @if (hasSelectedNode) {
      <!-- Edit -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          chartCurrentOrProposedId &&
            store.treeEditorFeature.actions.editNode
              .from('OrgChartTools.EditButton.Clicked')
              .dispatch({ chartId: chartCurrentOrProposedId })
        "
      >
        <i class="atn-icon atn-edit atn-blue"></i>
      </atn-ds-button>

      <!-- Delete -->
      @if (chartProposedId) {
        <atn-ds-button
          class="atn-summit-org-chart-tools__button"
          [isIcon]="true"
          type="white"
          [loading]="isMutating"
          (click)="
            chartCurrentOrProposedId &&
              !isMutating &&
              store.treeEditorFeature.actions.deleteNode
                .from('OrgChartTools.DeleteButton.Clicked')
                .dispatch({ chartId: chartCurrentOrProposedId })
          "
        >
          <i class="atn-icon atn-eraser atn-red"></i>
        </atn-ds-button>
      }
    }

    @let isAllExpanded = isAllNodesExpanded();
    <atn-ds-button
      class="atn-summit-org-chart-tools__button"
      [isIcon]="true"
      type="white"
      (click)="toggleExpandCollapseAll()"
    >
      <i
        class="atn-icon atn-blue"
        [class.atn-expand]="!isAllExpanded"
        [class.atn-contract]="isAllExpanded"
      ></i>
    </atn-ds-button>

    <!-- Undo -->
    @if (chartProposedId) {
      @if (
        chartCurrentOrProposedId &&
        store.treeEditorFeature.selectors
          .canUndo({ chartId: chartCurrentOrProposedId })
          .asSignal()
      ) {
        <atn-ds-button
          class="atn-summit-org-chart-tools__button"
          [isIcon]="true"
          type="white"
          (click)="
            chartCurrentOrProposedId &&
              store.treeEditorFeature.actions.undo
                .from('OrgChartTools.UndoButton.Clicked')
                .dispatch({ chartId: chartCurrentOrProposedId })
          "
        >
          <i class="atn-icon atn-undo atn-blue"></i>
        </atn-ds-button>
      }
    }

    <!-- Redo -->
    @if (chartProposedId) {
      @if (
        chartCurrentOrProposedId &&
        store.treeEditorFeature.selectors
          .canRedo({ chartId: chartCurrentOrProposedId })
          .asSignal()
      ) {
        <atn-ds-button
          class="atn-summit-org-chart-tools__button"
          [isIcon]="true"
          type="white"
          (click)="
            chartCurrentOrProposedId &&
              store.treeEditorFeature.actions.redo
                .from('OrgChartTools.RedoButton.Clicked')
                .dispatch({ chartId: chartCurrentOrProposedId })
          "
        >
          <i class="atn-icon atn-redo atn-blue"></i>
        </atn-ds-button>
      }
    }
  </div>

  <div class="atn-summit-org-chart-tools__group">
    <!-- Clear -->
    @if (chartCurrentId) {
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="confirmClearSg.set(true)"
      >
        <i class="atn-icon atn-trash atn-red"></i>
      </atn-ds-button>
    }
    @if (chartCurrentId) {
      @if (confirmClearSg()) {
        <atn-ds-confirmation-overlay
          title="Clear Everything?"
          description="This will wipe out everything in this org chart. Are you sure you want to proceed?"
          (cancel)="confirmClearSg.set(false)"
          (confirm)="
            chartCurrentId &&
              store.treeEditorFeature.actions.clear
                .from('OrgChartTools.ClearConfirmationButton.Clicked')
                .dispatch({ chartId: chartCurrentId });
            confirmClearSg.set(false)
          "
          confirmButtonText="Clear"
        />
      }
    }

    <!-- Clean Up -->
    @if (chartProposedId) {
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          chartCurrentOrProposedId &&
            store.treeEditorFeature.actions.cleanUp
              .from('OrgChartTools.CleanUpButton.Clicked')
              .dispatch({ chartId: chartCurrentOrProposedId })
        "
      >
        <i class="atn-icon atn-broom atn-blue"></i>
      </atn-ds-button>
    }

    @if (chartCurrentId) {
      <!-- Create Proposal -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          chartCurrentId &&
            store.treeEditorFeature.actions.propose
              .from('OrgChartTools.CreateProposalButton.Clicked')
              .dispatch(chartCurrentId)
        "
      >
        <i class="atn-icon atn-duplicate atn-blue"></i>
      </atn-ds-button>
    } @else if (chartProposedId) {
      <!-- Approve Proposal -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        [loading]="isMutating"
        (click)="
          chartProposedId &&
            !isMutating &&
            store.treeEditorFeature.actions.approveProposal
              .from('OrgChartTools.ApproveProposalButton.Clicked')
              .dispatch({ widgetRefId })
        "
      >
        <i class="atn-icon atn-approve"></i>
      </atn-ds-button>

      <!-- Reject Proposal -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          chartProposedId &&
            store.treeEditorFeature.actions.rejectProposal
              .from('OrgChartTools.RejectProposalButton.Clicked')
              .dispatch({ widgetRefId })
        "
      >
        <i class="atn-icon atn-close atn-red"></i>
      </atn-ds-button>
    }
  </div>
</div>
